import {styled} from '@mui/material/styles';

/**
 * Just a <button> with styles reset
 *
 * @deprecated use Material button
 */
export const TextButton = styled('button')({
  margin: 0,
  padding: 0,
  border: 'none',
  background: 'none',
  color: 'inherit',
  font: 'inherit',
  cursor: 'pointer',

  '&:disabled': {
    opacity: 0.38,
  },
});

TextButton.defaultProps = {
  type: 'button',
};
